/**
 * Custom PDP Accordion JS
 * Handles toggling of product detail accordions without affecting other theme elements.
 */
(function() {
    'use strict';
  
    function initPdpAccordions() {
      const accordionHeaders = document.querySelectorAll('.pdp-accordion__header');
      
      accordionHeaders.forEach(header => {
        // Avoid duplicate listeners
        if (header.dataset.accordionLoaded) return;
        header.dataset.accordionLoaded = 'true';
  
        header.addEventListener('click', function() {
          const item = this.parentElement;
          const content = this.nextElementSibling;
          const isOpen = item.classList.contains('is-open');
  
          // Toggle state
          if (isOpen) {
            // Set back to current height for animation to work from 'none'
            content.style.maxHeight = content.scrollHeight + 'px';
            content.offsetHeight; // force reflow
            
            item.classList.remove('is-open');
            header.setAttribute('aria-expanded', 'false');
            content.style.maxHeight = null;
          } else {  
            item.classList.add('is-open');
            header.setAttribute('aria-expanded', 'true');
            content.style.maxHeight = content.scrollHeight + "px";
            
            // Once transition is done, set to none to allow dynamic height (e.g. window resize)
            content.addEventListener('transitionend', function() {
              if (item.classList.contains('is-open')) {
                content.style.maxHeight = 'none';
              }
            }, { once: true });
          }
        });
      });
    }
  
    // Initialize on load
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      initPdpAccordions();
    } else {
      document.addEventListener('DOMContentLoaded', initPdpAccordions);
    }
  
    // Handle dynamic loading (e.g., variant changes if they re-render blocks)
    document.addEventListener('shopify:section:load', initPdpAccordions);
    
    // Expose to window for manual re-init if needed
    window.initPdpAccordions = initPdpAccordions;
  
  })();
  